// 企业标签
export const apiDirectoryLabelList =
  '/open/app/v1/enterprise/operating_condition/directory_label/list';

// 获取企业投资布局概要
export const apiInvestLayoutSummary = '/open/app/v1/enterprise/invest_layout/summary';

// 获取企业投资布局企业列表
export const apiInvestLayoutList = '/open/app/v1/enterprise/invest_layout/list';

// 近24小时监控
export const apiDailyStats = '/open/app/v1/yuqing/daily_stats';

// 批量查询企业舆情风险日报
export const apiDailyNews = '/open/app/v1/yuqing/daily_news';

// 近7日监控
export const apiWeeklyMonitorStats = '/open/app/v1/yuqing/weekly_monitor_stats';

// 批量查询近7日企业舆情咨询
export const apiWeeklyNews = '/open/app/v1/yuqing/weekly_news';

// 获取集团基本信息
export const apiGroupBasicInfo = '/open/app/v1/group/basic_info';

// 获取集团成员企业概述
export const apiGroupMemberSummary = '/open/app/v1/group/enterprise_member/summary';

// 获取集团成员企业列表
export const apiGroupMemberList = '/open/app/v1/group/enterprise_member/list';

// 当前APP市场审核状态
export const apiReviewInfo = '/open/app/v1/config/mobile/review_info';

// 首字母排序地区
export const apiSortByInitialArea = '/open/app/v1/area_info';
// 只取省和地级市
export const apiGetProvinceAndCity = '/open/app/v1/province_info';
// 获取附近爆雷企业
export const apiGetNearBreakCompany = '/open/app/v1/exposed_risk/nearby_enterprise';
// 获取配置爆雷企业
export const apiGetConfigBreakCompany = '/open/app/v1/exposed_risk/categorized_enterprise';
// 爆雷查询
export const apiSearchBreakCompany = '/open/app/v1/exposed_risk/query';
// 爆雷品牌基本信息
export const apiBreakCompanyDetail = '/open/app/v1/exposed_risk/subject_info';
// 企业爆雷特征列表
export const apiBreakRiskList = '/open/app/v1/exposed_risk/list';
// 用户爆料列表
export const apiGetDisclosuresList = '/open/app/v1/exposed_risk/user_reporting_list';
// 我要爆料-提交
export const apitDisclosuresCommit = '/open/app/v1/exposed_risk/reporting_commit';
// 关联企业暴雷列表
export const apiGetRelatedCompanyList = '/open/app/v1/exposed_risk/related_enterprise/list';
// 关联企业暴雷简介
export const apiGetRelatedComapnyInfo =
  '/open/app/v1/exposed_risk/related_enterprise/brief_introduction';
// 获取服务端存储的push开关信息
export const apiGetPushSwitchStatus = `/open/app/v1/config/switch/batch/get_flag`;
// 完成用户任务
export const apiTaskUserAccomplish = `/open/app/user/v1/app_grade_task/user_accomplish`;
// 获取会员任务状态
export const apiGetUserTaskStatus = `/open/app/user/v1/app_grade_task/query`;
// 获取企业产业链统计
export const apiGetCompanyIndustry = `/open/app/v1/enterprise/operating_condition/enterprise_chain_stats`;
